import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import React, { Component }  from 'react';
import {Tab, Row, Col} from "react-bootstrap";
import {SketchPicker} from "react-color";
import reactCSS from 'reactcss'
import {sleep} from "./AddBrandModal";
import { apiFetch, API, getMarket } from "../../services/api";


// « a-m, b-w » → ["a-m", "b-w"] (vides retirés).
function splitSlugs(value) {
    return String(value || "").split(",").map(v => v.trim()).filter(v => v !== "");
}

export default class AddHomeAppearanceSlide extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayColorPickerText: false,
            displayColorPickerButton: false,
            colorText: {
                r: 255,
                g: 255,
                b: 255,
                a: 100,
            },
            homeAppeareanceImg: "",
            desktopHomeAppeareanceImg: "",
        };
        this.uploadHomeAppearanceImg = this.uploadHomeAppearanceImg.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }


    handleClickText = () => {
        this.setState({ displayColorPickerText: !this.state.displayColorPickerText })
    };

    handleCloseColorText = () => {
        this.setState({ displayColorPickerText: false })
    };

    handleChangeTextColor = (color) => {
        this.props.selectedSlide.textColor = color.rgb
        this.setState({ colorText: color.rgb })
    };


    uploadHomeAppearanceImg(e, slide) {
        const file = e.target.files[0]
        const fileName = e.target.files[0].name
        const reader = new FileReader()

        reader.readAsDataURL(file)

        reader.onload = () => {
            fetch('https://back-api.therunningcollective.fr/upload-file', {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    blob:reader.result,
                    fileName: "apperance/"+fileName
                })}).then((res) =>
            res.json().then( result =>{
                slide.image = result.message
                sleep(1000)
                this.setState({homeAppeareanceImg:  result.message});
            }))}
    }

    uploadDesktopHomeAppearanceImg(e, slide) {

        const file = e.target.files[0]
        const fileName = e.target.files[0].name
        const reader = new FileReader()

        reader.readAsDataURL(file)

        reader.onload = () => {
            fetch('https://back-api.therunningcollective.fr/upload-file', {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    blob:reader.result,
                    fileName: "apperance/"+fileName
                })}).then((res) =>
            res.json().then( result =>{
                slide.desktopImage = result.message
                sleep(1000)
                this.setState({desktopHomeAppeareanceImg:  result.message});
            }))}
    }


    handleClose() {
        var products = []
        if(this.props.selectedSlide.products){
            this.props.selectedSlide.products.map(item =>{
                if (item.shortURL  && item.shortURL != ""){
                    products.push(item.shortURL)
                }
            })
            if (products.length == 0){
                products = this.props.selectedSlide.products
            }
        }

        this.props.selectedSlide.products = products
        this.props.selectedSlide.language = getMarket()

        apiFetch(API.back + '/appearance', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.props.selectedSlide)
        })
            .then( () => (
                this.props.closeModal,
                window.location.reload(false)))
            .catch( err =>
                console.log(err)
            );
    }

    render(){
        if(this.props.selectedSlide.order == -1){
            this.props.selectedSlide.order = 1000;
        }
        this.props.selectedSlide.type = this.props.headCategory;

        const stylesText = reactCSS({
            'default': {
                color: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: `rgba(${ this.props.selectedSlide.textColor.r }, ${ this.props.selectedSlide.textColor.g }, ${ this.props.selectedSlide.textColor.b }, ${ this.props.selectedSlide.textColor.a })`,
                },
                swatch: {
                    padding: '5px',
                    marginLeft: '15px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });

        return(
            <Modal
                show={this.props.isOpen}
                onHide={this.props.closeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Ajouter une slide</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        <Row>
                            <Col>
                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <Form.Group >
                                            <Form.Label>Titre : </Form.Label>
                                            <Form.Control type="text" onChange={(e) => this.props.selectedSlide.title = e.target.value} defaultValue={this.props.selectedSlide.title} placeholder="Ex : Home 1"/>
                                        </Form.Group>

                                        <Form.Group >
                                            <Form.Label>(Mobile) Image de couverture : </Form.Label>
                                            <Form.File
                                                id="custom-first-img-translate-html"
                                                label="Ajouter un image"
                                                data-browse="Ajouter"
                                                onChange= {(e) => {this.uploadHomeAppearanceImg(e, this.props.selectedSlide)}}
                                                custom
                                            />
                                            {this.props.selectedSlide.image ?
                                                <img className="imgToDisplay" alt="Couverture actuelle" src={this.props.selectedSlide.image}/>
                                                :
                                                null
                                            }
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>(Ordinateur) Image de couverture : </Form.Label>
                                            <Form.File
                                                id="custom-first-img-translate-html"
                                                label="Ajouter un image"
                                                data-browse="Ajouter"
                                                onChange= {(e) => {this.uploadDesktopHomeAppearanceImg(e, this.props.selectedSlide)}}
                                                custom
                                            />
                                            {this.props.selectedSlide.desktopImage ?
                                                <img className="imgToDisplay" alt="Couverture actuelle" src={this.props.selectedSlide.desktopImage}/>
                                                :
                                                null
                                            }
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Contraste : </Form.Label>
                                            <Form.Control
                                                as="select"
                                                custom
                                                onChange={(e) => this.props.selectedSlide.contrast = e.target.value}
                                                defaultValue={this.props.selectedSlide.contrast}
                                            >
                                                <option value="0">0</option>
                                                <option value="0.1">0.1</option>
                                                <option value="0.2">0.2</option>
                                                <option value="0.3">0.3</option>
                                                <option value="0.4">0.4</option>
                                                <option value="0.5">0.5</option>
                                                <option value="0.6">0.6</option>
                                                <option value="0.7">0.7</option>
                                                <option value="0.8">0.8</option>
                                                <option value="0.9">0.9</option>
                                                <option value="1">1</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Texte : </Form.Label>
                                            <Form.Control as="textarea" rows={4} onChange={(e) => this.props.selectedSlide.subtitle = e.target.value} defaultValue={this.props.selectedSlide.subtitle} placeholder="Cette chaussure est ..."/>
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Couleur du texte :
                                                <div style={ stylesText.swatch } onClick={ this.handleClickText }>
                                                    <div style={ stylesText.color } />
                                                </div>
                                                { this.state.displayColorPickerText ? <div style={ stylesText.popover }>
                                                    <div style={ stylesText.cover } onClick={ this.handleCloseColorText }/>
                                                    <SketchPicker color={ this.props.selectedSlide.textColor } onChange={ this.handleChangeTextColor } />
                                                </div> : null }
                                            </Form.Label>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Texte du bouton : </Form.Label>
                                            <Form.Control type="text" onChange={(e) => this.props.selectedSlide.buttonText = e.target.value} defaultValue={this.props.selectedSlide.buttonText} placeholder="Ex : Découvrir"/>
                                        </Form.Group>
                                        <Form.Group >
                                            <Form.Label>Lien du bouton : </Form.Label>
                                            <Form.Control type="text" onChange={(e) => this.props.selectedSlide.url = e.target.value} defaultValue={this.props.selectedSlide.url} placeholder="Ex : https://therunningcollective.fr/"/>
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Type de produit : </Form.Label>
                                            <Form.Control
                                                as="select"
                                                multiple
                                                onChange={(e) => this.props.selectedSlide.shopTypeNG = [...e.target.selectedOptions].map(o => o.value)}
                                                defaultValue={this.props.selectedSlide.shopTypeNG}
                                            >
                                                <option key="athletisme" value="athletisme">Athlétisme</option>
                                                <option key="running" value="running">Running</option>
                                                <option key="trail" value="trail">Trail</option>
                                                <option key="home" value="home">Accueil du site</option>
                                            </Form.Control>
                                        </Form.Group>
                                        {
                                            this.props.headCategory == "/appearance/home/infinite-products" ?
                                            <>
                                            {/* Blocs « gammes » : liste recalculée chaque nuit par home-ranges-updater
                                                (popularité 30 j) ; épinglés en tête, exclus jamais affichés. */}
                                            <Form.Group>
                                                <Form.Label>Mise à jour automatique :</Form.Label>
                                                <Form.Control as="select"
                                                    defaultValue={this.props.selectedSlide.autoRule || ""}
                                                    onChange={(e) => this.props.selectedSlide.autoRule = e.target.value}>
                                                    <option value="">Aucune (liste manuelle)</option>
                                                    <option value="marathon-carbon">Marathon carbone</option>
                                                    <option value="race-10k">10 km</option>
                                                    <option value="training-sessions">Séances</option>
                                                    <option value="daily-training">Au quotidien</option>
                                                </Form.Control>
                                                {this.props.selectedSlide.autoUpdatedAt && !String(this.props.selectedSlide.autoUpdatedAt).startsWith("0001") ?
                                                    <small className="text-muted">Liste recalculée automatiquement le {new Date(this.props.selectedSlide.autoUpdatedAt).toLocaleString("fr-FR")}</small>
                                                    : null}
                                            </Form.Group>
                                            <Form.Group>
                                                <Form.Label>Épinglés (toujours en tête, slugs séparés par des virgules) :</Form.Label>
                                                <Form.Control type="text" placeholder="adidas-adizero-adios-pro-5-m, nike-alphafly-3-m"
                                                    defaultValue={(this.props.selectedSlide.pinnedProducts || []).join(", ")}
                                                    onChange={(e) => this.props.selectedSlide.pinnedProducts = splitSlugs(e.target.value)}/>
                                            </Form.Group>
                                            <Form.Group>
                                                <Form.Label>Exclus (jamais affichés) :</Form.Label>
                                                <Form.Control type="text" placeholder="nike-zoomx-vaporfly-next-3-m"
                                                    defaultValue={(this.props.selectedSlide.excludedProducts || []).join(", ")}
                                                    onChange={(e) => this.props.selectedSlide.excludedProducts = splitSlugs(e.target.value)}/>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Produits éligibles{this.props.selectedSlide.autoRule ? " (remplacés chaque nuit par la règle automatique)" : ""} : </Form.Label>
                                                    <Form.Control
                                                        as="select"
                                                        multiple
                                                        onChange={(e) => {this.props.selectedSlide.products = [...e.target.selectedOptions].map(o => this.props.availableProducts.find(product =>  product.shortURL === o.value))}}
                                                        defaultValue={getSelectedItems(this.props.selectedSlide.products)}
                                                    >
                                                        {this.props.availableProducts.map((product, index) =>
                                                            <option key={index} value={product.shortURL}>{product.name}</option>
                                                        )}
                                                </Form.Control>
                                            </Form.Group>
                                            </>
                                            : <Form.Group >
                                                <Form.Label>Filtre : </Form.Label>
                                                <Form.Control type="text" onChange={(e) => this.props.selectedSlide.filter = e.target.value} defaultValue={this.props.selectedSlide.filter} placeholder="Ex : ?page=1&brand=nike&gender=Men"/>
                                            </Form.Group>
                                        }
                                        
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" type="cancel" onClick={this.props.closeModal}>
                        Annuler
                    </Button>
                    <Button variant="primary" type="submit" onClick={this.handleClose}>
                        Valider
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

function getSelectedItems(items){
    var arrayToReturn = []

    if (items) {
        items.map(item =>(
                arrayToReturn.push(item)
            )
        )
    }

    return arrayToReturn
}